import { FeatureToggle, useGetFeatureTogglesForUser } from './api/queries';
import { FEATURE_TOGGLES } from './feature-toggles';

interface FeatureToggleReturnType {
  isFeatureOn: boolean;
  isLoading: boolean;
}

export const useCenSolV2FeatureToggle = (): FeatureToggleReturnType => {
  const getFeatureTogglesQuery = useGetFeatureTogglesForUser();
  const isCensolV2FeatureOn =
    getFeatureTogglesQuery.data?.some(
      (featureToggle: FeatureToggle) => featureToggle.uniqueName === FEATURE_TOGGLES.CEN_SOL_V2
    ) ?? false;
  return { isFeatureOn: isCensolV2FeatureOn, isLoading: getFeatureTogglesQuery.isLoading };
};
